import React from "react";
import * as Styled from "./styles";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { onModal } from "../../../stores/modals";
import { phoneNumberFormatting } from "../../../middlewares";

import { Link } from "react-router-dom";

interface dataProps {
  title?: string;
  data?: {
    summary: any;
    transactions: any;
  };
  summaryData?: {
    originalPrice: number;
    discount: number;
    unpaidPrice: number;
    paidPrice: number;
    refundPrice: number;
  };
}

const dynamicState = (data: any, t: any) => {
  switch (data.status) {
    case 0:
      return {
        type: 0,
        status: t("components.purchaseTable.incompletedPayment")
      };
    case 1:
      return { type: 1, status: t("components.purchaseTable.payment") };
    case 2:
      return { type: 2, status: t("components.purchaseTable.refund") };
    case 3:
      return {
        type: 3,
        status: t("components.purchaseTable.deleted"),
        className: "deleted"
      };
    default:
      return { status: "" };
  }
};

const TotalPurchaseTable = ({ title, data, summaryData }: dataProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div>
      {data ? (
        <Styled.ListAll top>
          <div className="newPurchaseWrapper">
            <div className="newPurchase">
              {title} [
              {data.transactions?.length > 0 ? data.transactions?.length : 0}]
              <span>
                {data.summary?.newUserCount >= 0 &&
                  `,${t("components.purchaseTable.newMember")} [${
                    data.summary?.newUserCount
                  }]`}
              </span>
            </div>
          </div>
          <hr />
          <br />
          <Styled.Table>
            <table>
              <thead>
                <tr>
                  <td>{t("accounting.order_no")}</td>
                  <td>{t("accounting.payment_date")}</td>
                  <td>{t("accounting.name")}</td>
                  <td>{t("accounting.tel")}</td>
                  <td>{t("accounting.payment")}</td>
                  <td>{t("accounting.status")}</td>
                  <td>{t("accounting.originalPrice")}</td>
                  <td>{t("accounting.discount")}</td>
                  <td>{t("accounting.unpaidPrice")}</td>
                  <td>{t("accounting.paidAmount")}</td>
                  <td>{t("accounting.refund")}</td>
                  <td>{t("accounting.paymentMethod")}</td>
                  <td>{t("accounting.employee")}</td>
                  <td>{t("accounting.memo1")}</td>
                  <td>{t("accounting.refund_memo")}</td>
                </tr>
              </thead>
              <tbody>
                {data.transactions?.map((n: any) => {
                  const nowState = dynamicState(n, t);
                  return (
                    <tr className={nowState.className} key={n.no}>
                      <td>{n.no}</td>
                      <td>{dayjs(n.purchaseDate).format("YYYY. MM. DD")}</td>
                      <td>
                        <Link to={`/admin/user/${n.userid}`}>
                          {" "}
                          {n.username}{" "}
                        </Link>
                      </td>
                      <td>
                        <Link to={`/admin/user/${n.userid}`}>
                          {" "}
                          {phoneNumberFormatting(n.phoneNumber)}
                        </Link>
                      </td>
                      <td>{n.ticketName}</td>
                      {nowState?.type === 0 && (
                        <td>
                          <div style={{ display: "flex" }}>
                            <Styled.Circle red />
                            {nowState?.status}
                          </div>
                        </td>
                      )}
                      {nowState?.type === 1 && (
                        <td>
                          <div style={{ display: "flex" }}>
                            <Styled.Circle />
                            {nowState?.status}
                          </div>
                        </td>
                      )}
                      {nowState?.type === 2 && (
                        <td>
                          <div style={{ display: "flex" }}>
                            <Styled.Circle empty />
                            {nowState?.status}
                          </div>
                        </td>
                      )}
                      {nowState?.type === 3 && (
                        <td>
                          <div style={{ display: "flex" }}>
                            <Styled.Circle empty />
                            {nowState?.status}
                          </div>
                        </td>
                      )}
                      <td className="price">
                        {n.originalPrice.toLocaleString("en")} {t("common.KRW")}
                      </td>
                      <td className="price">
                        {n.discount.toLocaleString("en")} {t("common.KRW")}
                      </td>
                      <td className="price">
                        {n.unpaidPrice.toLocaleString("en")} {t("common.KRW")}
                      </td>
                      <td className="price">
                        {n.paidAmount && n.paidAmount.toLocaleString("en")}{" "}
                        {t("common.KRW")}
                      </td>
                      <td className="price">
                        {n.refund.toLocaleString("en")} {t("common.KRW")}
                      </td>
                      <td>{n.method}</td>
                      <td>{n.employee}</td>
                      <td>
                        {n.transactionMemo && n.transactionMemo.length > 0 && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              dispatch(
                                onModal("memo", {
                                  type: "memo",
                                  data: n.transactionMemo
                                })
                              )
                            }
                          >
                            {t("components.purchaseTable.comments")}
                          </div>
                        )}
                      </td>
                      <td>
                        {n.refundMemos && n.refundMemos.length > 0 && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              dispatch(
                                onModal("memo", {
                                  type: "refund",
                                  data: n.refundMemos
                                })
                              )
                            }
                          >
                            {t("components.purchaseTable.comments")}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={6} style={{ fontWeight: "bold" }}>
                    {t("components.purchaseTable.sum")}
                  </td>
                  <td className="price">
                    {summaryData?.originalPrice.toLocaleString("en")}{" "}
                    {t("common.KRW")}
                  </td>
                  <td className="price">
                    {summaryData?.discount.toLocaleString("en")}{" "}
                    {t("common.KRW")}
                  </td>
                  <td className="price">
                    {summaryData?.unpaidPrice.toLocaleString("en")}{" "}
                    {t("common.KRW")}
                  </td>
                  <td className="price">
                    {summaryData?.paidPrice.toLocaleString("en")}{" "}
                    {t("common.KRW")}
                  </td>
                  <td className="price">
                    {summaryData?.refundPrice.toLocaleString("en")}{" "}
                    {t("common.KRW")}
                  </td>
                  <td colSpan={4}></td>
                </tr>
              </tbody>
            </table>
          </Styled.Table>
        </Styled.ListAll>
      ) : (
        <>
          <div>{t("components.purchaseTable.failedToload")}</div>
        </>
      )}
    </div>
  );
};

export default TotalPurchaseTable;
